import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ImageUploaderComponent } from './image-uploader.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
    declarations: [ImageUploaderComponent],
    imports: [CommonModule, TranslateModule, FileUploadModule, ConfirmDialogModule],
    exports: [ImageUploaderComponent],
})
export class ImageUploaderModule {}
